var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25012 14C6.34519 13.2289 5.65791 12.2507 5.18826 11.0654C4.73007 9.86847 4.50098 8.51624 4.50098 7.00863C4.50098 5.48952 4.73007 4.13728 5.18826 2.95191C5.65791 1.76654 6.34519 0.782573 7.25012 0H9.50098C8.69914 0.678997 8.06913 1.64571 7.61094 2.90012C7.15275 4.15454 6.92366 5.52404 6.92366 7.00863C6.92366 8.49322 7.15275 9.86272 7.61094 11.1171C8.08059 12.3601 8.7106 13.321 9.50098 14H7.25012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBrace);
export default __webpack_public_path__ + "static/media/leftBrace.38e5476dbaf3528c14641c1c9e5a1d33.svg";
export { ForwardRef as ReactComponent };